import envJsonFile from "./env.json";

// "development": {
    //     "hubUrl": "https://localhost:7252",
    //     "hubBackupUrls": ["https://backup1.example.com"],
    //     "secretKey": "dspro-b9TFnY3R4dyTjOgk0GdPyS2StXVMEB"
    // },

class Environment {

    public static instance:Environment = new Environment();

    // The hub URL this tab settled on at load (see resolveHubUrl). Unset until then, and
    // unset for good when the host has no backups, in which case hubUrl is the primary.
    private static activeHubUrl?: string;
    
    isDevelopment: boolean;
    isProduction: boolean;
    env: any;
    // Fallback hub URLs, tried in order when the primary hubUrl does not answer at load.
    hubBackupUrls: string[];
    wssHost: string;
    dashboardUrl: string;
    secretKey: string;
    versionNumber:number;
    versionName:string;
    signUp:boolean;
    signUpDispatchers: boolean;
    flexibleDispatchers: boolean;
    brand: string;
    siteTitle: string;
    // Cloudflare Turnstile site key for the signup bot check. Public by design -- the
    // matching secret lives on the HUB and is what actually validates a token.
    turnstileSiteKey: string;


    constructor() {
        this.isDevelopment = (!process.env.NODE_ENV || process.env.NODE_ENV === 'development');
        this.isProduction = !this.isDevelopment;
        let envJson:any = envJsonFile;
        this.env = envJson[window.location.host];
        this.hubBackupUrls = this.env.hubBackupUrls ?? [];
        this.wssHost = this.env.wssHost;
        this.dashboardUrl = this.env.dashboardUrl;
        this.secretKey = this.env.secretKey;
        this.versionNumber = envJson.version.number;
        this.versionName = envJson.version.name;
        this.signUp = this.env.signUp;
        this.signUpDispatchers = this.env.signUpDispatchers;
        this.flexibleDispatchers = this.env.flexibleDispatchers;
        this.brand = this.env.brand;
        this.siteTitle = this.env.siteTitle;
        this.turnstileSiteKey = this.env.turnstileSiteKey;
    }

    // Single HUB base URL: serves the API, CDN files and the SignalR socket. A getter, so
    // instances created before resolveHubUrl finished still read the URL the tab chose.
    get hubUrl(): string {
        return Environment.activeHubUrl ?? this.env.hubUrl;
    }

    get localHubUrl(): string {
        return this.env.localHubUrl ?? this.hubUrl;
    }

    /**
     * Picks the hub this tab talks to until it is closed or reloaded. The primary hubUrl is
     * probed first; if it fails for any reason, each of hubBackupUrls is probed top to bottom
     * and the first healthy one wins. If none answers, the primary is kept so the app shows
     * its usual connection errors. Hosts without backups skip the probe entirely.
     */
    static async resolveHubUrl(): Promise<string> {
        const env = Environment.instance;
        const trim = (url: string) => url.replace(/\/+$/, "");
        const primary = trim(env.env.hubUrl);
        const backups = env.hubBackupUrls.map(trim).filter((url, i, all) => url && url !== primary && all.indexOf(url) === i);
        if (backups.length === 0) return primary;

        for (const url of [primary, ...backups]) {
            if (await Environment.isHubHealthy(url)) {
                Environment.activeHubUrl = url;
                if (url !== primary) console.warn(`Primary hub ${primary} is unreachable; using backup ${url}`);
                return url;
            }
        }

        console.error("No hub answered the health check; staying on the primary", primary);
        Environment.activeHubUrl = primary;
        return primary;
    }

    private static async isHubHealthy(url: string, timeoutMs: number = 4000): Promise<boolean> {
        const controller = new AbortController();
        const timer = setTimeout(() => controller.abort(), timeoutMs);
        try {
            const res = await fetch(url + "/base/public/health", { cache: "no-store", signal: controller.signal });
            return res.ok;
        } catch {
            return false;
        } finally {
            clearTimeout(timer);
        }
    }

}

export default Environment;